import { useContext } from 'preact/hooks';
import { AccessibleContext } from './AccessibleContext';

/**
 * Utility hook for consuming the AccessibleContext
 *
 * @returns The value of closest AccessibleContext provider
 */
function useAccessibleContext() {
  return useContext(AccessibleContext);
}

export { useAccessibleContext };
